import { AnyAction, combineReducers, createAsyncThunk } from '@reduxjs/toolkit';

import { editorReducer } from './editor/EditorSlice';

const reducers = {
  editor: editorReducer,
};
const rootReducer = combineReducers(reducers);
export const resettableRootReducer = (state: ReturnType<typeof rootReducer> | undefined, action: AnyAction) => {
  if (action.type === 'store/reset') {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};
export const resetStore = createAsyncThunk('store/reset', (payload, { dispatch }) => {
  dispatch({ type: 'store/reset' });
});
